import { ref } from 'vue';

// 2025 09 15 block for t_field
//import { PmsAccess, } from '@/classes/DbAccess/PmsAccess.js';

class UserInfo {
    constructor() {
        
        this.isLoggedIn = ref(false);
        this.username = ref('');
        this.userrole = ref('');

        this.body = {};

        this.current_component = ref('');
        
    }

    set_isLoggedIn(param) { this.isLoggedIn.value = param; }
    set_username(param) { this.username.value = param; }
    set_userrole(param) { this.userrole.value = param; }
    set_current_component(param) { this.current_component.value = param; }

    get_username() { return this.username.value; }
    get_userrole() { return this.userrole.value; }
    get_isLoggedIn() { return this.isLoggedIn.value; }
    get_current_component() { return this.current_component.value; }

    /*
        for security reason, we use "POST" instead of "GET"
        
        /api/login
        body: {loginid, password}
    */
    async check_login(loginid, password) {
        /*  t_field를 위해 막음
        let dbaccess = new PmsAccess();
        let data = {loginid, password};
        await dbaccess.fetch_pms("Login", 'login', data);

        // this.pms_response is the property of parent 'PmsAccess'
        if (dbaccess.pms_response.type == 'success') {
            this.isLoggedIn.value = true;
            this.username.value = dbaccess.pms_response.response.username;
            this.userrole.value = dbaccess.pms_response.response.role;
        }
        */

        // start of t_field 2025 09 15
        if (loginid=='hgkim77@hotmail.com' && password=='soph') {
            this.isLoggedIn.value = true;
            this.username.value = 'hgkim';
            this.userrole.value = 'user';
            // 2025 09 12 App.vue의 created에서 처리함 //accounting.set_userrole('user');
        }
        else if (loginid=='skpark1@naver.com' && password=='12341234') {
            this.isLoggedIn.value = true;
            // 2025 09 17 t_field this.username.value = 'skpark1';
            this.username.value = 'pms';
            this.userrole.value = 'manager1';
            // 2025 09 12 App.vue의 created에서 처리함 //accounting.set_userrole('user');
        }
        else if (loginid=='skpark2@naver.com' && password=='12345') {
            this.isLoggedIn.value = true;
            this.username.value = 'Sophpms';
            // 2025 09 17 t_field this.username.value = 'skpark2';
            this.userrole.value = 'manager2';
            // 2025 09 12 App.vue의 created에서 처리함 //accounting.set_userrole('user');
        }
        else {
            this.isLoggedIn.value = false;
            this.username.value = 'null';
            this.userrole.value = 'null';
            // 2025 09 12 App.vue의 created에서 처리함 //accounting.set_userrole('user');
        }
    }
}

export let userinfo = new UserInfo();
